<template>
  <div class="page-container">
    <!-- 面包屑导航 -->
    <!-- <div class="nav-container"> -->
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/scheme/details/4183110027772685042.html?demo=1">
            货车运输轨迹
          </router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item> 轨迹回放 </el-breadcrumb-item>
        <el-breadcrumb-item> Demo演示 </el-breadcrumb-item>
      </el-breadcrumb> -->
    <!-- </div> -->

    <!-- 地图容器 -->
    <div ref="mapBox" class="mapContainer" id="container"></div>

    <!-- 工具栏 -->
    <div class="toolBar">
      <el-select
          v-model="formItem.vno"
          class="inp1"
          filterable
          allow-create
          placeholder="查询车辆"
          size="small"
          @change="handleVehicleChange"
      >
        <template v-for="(vehicle, index) in vehicleSelectData">
          <el-option
              :key="index"
          :value="vehicle.value"
          :label="vehicle.label"
          >
          <div class="optItem"
               :class="{
          optItem2: vehicle.vco === '2',
          optItem1: vehicle.vco === '1',
          optItem3: vehicle.vco === '3',
          optItem5: vehicle.vco === '5',
          optItem6: vehicle.vco === '6'
        }"
          >
            {{ vehicle.vno }}
          </div>
          </el-option>
        </template>
        <el-option
            v-if="vehicleSelectData.length === 0"
            value=""
            disabled
        >
          暂无搜索历史
        </el-option>
      </el-select>

      <el-select
          v-model="formItem.vco"
          class="inp2"
          placeholder="车牌颜色"
          size="small"
          clearable
      >
        <el-option label="蓝色" value="1"></el-option>
        <el-option label="黄色" value="2"></el-option>
        <el-option label="黑色" value="3"></el-option>
        <el-option label="白色" value="4"></el-option>
        <el-option label="黄绿色" value="5"></el-option>
        <el-option label="绿色" value="6"></el-option>
        <el-option label="其他" value="9"></el-option>
      </el-select>

      <el-date-picker
          v-model="formItem.startTime"
          class="inp3"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="timestamp"
          placeholder="开始时间"
          size="small"
          clearable
          :picker-options="{ disabledDate: disabledStartDate }"
      ></el-date-picker>

      <el-date-picker
          v-model="formItem.endTime"
          class="inp3"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="timestamp"
          placeholder="结束时间"
          size="small"
          clearable
          :picker-options="{ disabledDate: disabledEndDate }"
      ></el-date-picker>

      <el-button
          type="primary"
          size="small"
          @click="handleSearch(true)"
      >
        搜索
      </el-button>
    </div>

    <!-- 进度控制栏 -->
    <div class="progressbarBox">
      <div class="progressBar">
        <span class="startTime">{{ barStartTime }}</span>
        <el-slider
            v-model="sliderVal"
            class="bar"
            :show-tooltip="false"
            :step="0.001"
            :disabled="!isCanPlay"
            @change="handleSliderChange"
        ></el-slider>
        <span class="endTime">{{ barEndTime }}</span>
        <span
            v-if="playStatus === 'stop' || playStatus === 'pause'"
            class="icon"
            :class="{ isCanPlay: isCanPlay }"
            @click="handlePlay"
        ></span>
        <span
            v-if="playStatus === 'start'"
            class="iconPause"
            @click="handlePause"
        ></span>
      </div>

      <div class="changeSpeed">
        <el-popover
            v-model="speedMod"
            width="80"
            offset="25"
            placement="top"
            trigger="click"
            popper-class="speedSelectBox"
        >
          <div class="speedSelect">
            <span
                v-for="speed in speedList"
                :key="speed.value"
                @click="handleSpeedChange(speed)"
            >
              {{ speed.label }}
            </span>
          </div>
          <span slot="reference" class="changeSpeedText">{{ speedName }}</span>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import { vehicleList } from '../data/vehicleData';
import { trackData0, trackData1, trackData2, trackData3 } from '../data/trackData';
import { parseTracePoints, formatTime, getGpsStatusConfig } from '../utils';
import carIcon from '../assets/img/icon-08.28381b4.png';
import startIcon from '../assets/img/icon-14.349b807.png';
import endIcon from '../assets/img/icon-15.9ba2ac8.png';
import stopIcon from '../assets/img/icon-16.fb30506.png';

export default {
  name: 'Track',
  head() {
    return this.$setHead({
      title: "轨迹回放_Demo演示_物流科技能力平台_中交兴路",
      keywords: "物流科技,中交兴路,物流解决方案,货运,公路货运,物联网,车联网,数字化物流,物流可视化,运输可视化,实时运输情况,运输管理,智能调度,IOT,TMS,网络货运,数字化厂区",
      description: "中交兴路物流科技能力平台，结合自身在北斗时空应用、物流AI、物联网等领域的专精优势打造物流数字化APaaS开放平台，拓展了物流运输可视化、数字化厂区物流协同、一站式货物跟踪、时空网格运输节点为代表的多个物流主场景，为物流行业的降本增效、低碳运行赋能。"
    });
  },
  data() {
    return {
      AMap: null,
      mapInstance: null,
      geocoder: null,
      infoWindow: null,
      pathSimplifierIns: null,
      navg: null,
      markerStopIcon: null,
      markerStart: null,
      markerEnd: null,
      markerStopList: [],
      formItem: {
        vno: "",
        vco: "",
        startTime: "",
        endTime: ""
      },
      isCanPlay: false,
      distanceAll: 0,
      sliderVal: 0,
      barStartTime: "00:00",
      barEndTimes: 0,
      barEndTime: "00:00",
      playStatus: "stop",
      speedMod: false,
      baseSpeed: 100,
      speedName: "倍速",
      speedList: [
        { label: "50.0X", value: 50 },
        { label: "20.0X", value: 20 },
        { label: "10.0X", value: 10 },
        { label: "5.0X", value: 5 },
        { label: "1.0X", value: 1 }
      ],
      traceList: [],
      showTrackParkingDetailList: [],
      pauseDistance: 0, // 新增：记录暂停时的行驶距离
    };
  },
  computed: {
    vehicleSelectData() {
      return vehicleList.map(vehicle => this.formatVehicleOption(vehicle));
    },
    vehicleTrackMap() {
      const map = new Map();
      this.vehicleSelectData.forEach((vehicle, index) => {
        const trackKey = `trackData${index % 4}`;
        map.set(vehicle.vno, trackKey);
      });
      return map;
    },
    currentVno() {
      return this.formItem.vno.split(",")[0];
    }
  },
  async mounted() {
    this.initForm();
    this.AMap = await this.$createAMap();
    this.mapInstance = new this.AMap.Map("container", {
      zoom: 12, // 初始缩放级别（确保能看到轨迹范围）
      center: [108.7, 34.3] // 轨迹大致中心点（匹配trackData中的经纬度范围）
    })
    const scaleControl = this.createScaleControl();
    this.mapInstance.addControl(scaleControl);
    this.initMapPlugins();
    this.createPathSimplifier();
    this.handleSearch(true);
  },
  methods: {
    initForm() {
      const query = this.$route.query;
      if (query.vno && query.vco) {
        this.formItem.vno = `${query.vno},${query.vco}`;
        this.formItem.vco = query.vco;
      }
      this.formItem.startTime = query.startTime || "";
      this.formItem.endTime = query.endTime || "";
    },
    handleVehicleChange() {
      const vco = this.formItem.vno.split(",")[1];
      if (vco) {
        this.formItem.vco = vco;
      }
    },
    // handlePlay() {
    //   if (!this.isCanPlay) {
    //     this.$message.error("暂无可播放轨迹");
    //     return;
    //   }
    //   if (this.playStatus === "stop" || this.playStatus === "pause") {
    //     this.navg && this.navg.start();
    //     this.playStatus = "start";
    //   } else {
    //     this.$message.error("未知状态播放无效");
    //   }
    // },
    // 修改play 函数
    handlePlay() {
      if (!this.isCanPlay) {
        this.$message.error("暂无可播放轨迹");
        return;
      }
      if (this.playStatus === "stop") {
        // 首次播放：从头开始
        this.navg && this.navg.start();
        this.playStatus = "start";
      } else if (this.playStatus === "pause") {
        // 暂停后继续：从暂停位置播放
        this.navg && this.navg.start(); // 先启动（从头）
        this.navg.pause(); // 暂停初始状态
        // 跳转到暂停的距离位置
        this.navg.moveByDistance(this.pauseDistance);
        this.navg.resume(); // 恢复播放
        this.playStatus = "start";
      } else {
        this.$message.error("未知状态播放无效");
      }
    },
    // 修改暂停函数
    handlePause() {
      if (this.playStatus === "start") {
        this.navg && this.navg.pause();
        // 新增：保存暂停时的行驶距离
        this.pauseDistance = this.navg.getMovedDistance();
        this.playStatus = "pause";
        this.setGeocoderAddress();
      } else {
        this.$message.error("不是播放状态暂停无效");
      }
    },
    // handlePause() {
    //   if (this.playStatus === "start") {
    //     this.navg && this.navg.pause();
    //     this.playStatus = "pause";
    //     this.setGeocoderAddress();
    //   } else {
    //     this.$message.error("不是播放状态暂停无效");
    //   }
    // },
    showInfoWindow(data) {
      const { lonlat, infoData } = data;
      this.infoWindow.setContent(this.createInfoWindowContent(infoData));
      if (this.infoWindow.getIsOpen()) {
        this.infoWindow.setPosition(lonlat);
      } else {
        this.infoWindow.open(this.mapInstance, lonlat);
      }
    },
    createInfoWindowContent(pointData) {
      const gpsTimeStr = this.$dayjs(Number(pointData.gpsTime)).format("YYYY-MM-DD HH:mm:ss");
      return `
        <div class="infoWidowBox">
          <div class="titleBox">
            <div class="vehInfo">
              <span class="vehNumber">${pointData.vno}</span>
            </div>
            <div class="speedBox">
              ${pointData.spd || "--"}km/h
            </div>
          </div>
          <div class="markerContent">
            <p class="markerLine">
              <span class="markerS1">状态：</span>
              <span class="markerS2">
                ${pointData.gpsTime ? getGpsStatusConfig(pointData.gpsStatus).str : "--"}/
                ${pointData.gpsTime ? pointData.acc === 1 ? "ACC开启" : "ACC关闭" : "--"}
              </span>
            </p>
            <p class="markerLine">
              <span class="markerS1">位置：</span>
              <span class="markerS2">${pointData.addr}</span>
            </p>
            <p class="markerLine">
              <span class="markerS1">时间：</span>
              <span class="markerS2">${gpsTimeStr || "--"}（模拟）</span>
            </p>
            ${pointData.roadLimitSpd ? `
              <p class="markerLine">
                <span class="markerS1">道路限速：</span>
                <span class="markerS2">${pointData.roadLimitSpd}km/h</span>
              </p>
            ` : ""}
          </div>
        </div>
      `;
    },
    // 新增，修改：根据滑块位置计算暂停进度
    handleSliderChange() {
      const targetDistance = this.distanceAll * (this.sliderVal / 100);
      this.pauseDistance = targetDistance; // 新增：同步滑块位置到暂停进度
      this.navg.stop();
      this.navg.start();
      this.navg.pause();
      this.playStatus = "pause";
      targetDistance === 0
          ? this.navg.moveToPoint(0)
          : this.navg.moveByDistance(targetDistance);
      this.pathSimplifierIns.renderLater();
      this.setGeocoderAddress();
    },
    // handleSliderChange() {
    //   const targetDistance = this.distanceAll * (this.sliderVal / 100);
    //   this.navg.stop();
    //   this.navg.start();
    //   this.navg.pause();
    //   this.playStatus = "pause";
    //   targetDistance === 0
    //       ? this.navg.moveToPoint(0)
    //       : this.navg.moveByDistance(targetDistance);
    //   this.pathSimplifierIns.renderLater();
    //   this.setGeocoderAddress();
    // },
    handleSpeedChange(speed) {
      this.navg && this.navg.setSpeed(this.baseSpeed * speed.value);
      this.speedName = speed.label;
      this.speedMod = false;
    },
    resetPlayStatus() {
      this.isCanPlay = false;
      this.distanceAll = 0;
      this.sliderVal = 0;
      this.barStartTime = "00:00";
      this.barEndTimes = 0;
      this.barEndTime = "00:00";
      this.playStatus = "stop";
      this.speedName = "倍速";
      this.traceList = [];
      this.markerStopList = [];
      this.showTrackParkingDetailList = [];
    },
    clearMap() {
      this.mapInstance && this.mapInstance.clearMap();
      this.pathSimplifierIns && this.pathSimplifierIns.setData([{ name: "路线", path: [] }]);
    },
    handleSearch(isManual = false) {
      const vehicle = this.findVehicleData();
      if (!isManual && !vehicle) {
        console.log("未找到该车辆");
        return;
      }
      this.clearMap();
      this.initStartEndMarkers();
      this.resetPlayStatus();
      this.loadTrackData();
    },
    findVehicleData() {
      return vehicleList.find(vehicle => vehicle.vno === this.currentVno);
    },
    loadTrackData() {
      const trackKey = this.vehicleTrackMap.get(this.currentVno);
      let trackData = null;

      switch (trackKey) {
        case "trackData0":
          trackData = trackData0;
          break;
        case "trackData1":
          trackData = trackData1;
          break;
        case "trackData2":
          trackData = trackData2;
          break;
        case "trackData3":
          trackData = trackData3;
          break;
        default:
          trackData = trackData0;
      }

      if (trackData) {
        this.traceList = parseTracePoints(trackData.traceList);
        const parkingList = trackData.parkInfo.trackParkingDetailList || [];
        if (parkingList.length) {
          this.showTrackParkingDetailList = parkingList;
          this.renderParkingMarkers();
        }
        this.renderTrackPath(this.traceList);
      }
    },
    renderTrackPath(tracePoints) {
      if (tracePoints.length === 0) return;

      const path = tracePoints.map(point => [point.lon, point.lat]);
      this.isCanPlay = true;

      this.pathSimplifierIns.show();
      this.pathSimplifierIns.setData([{ name: "路线", path }]);

      // 创建路径导航器（轨迹动画）
      this.navg = this.pathSimplifierIns.createPathNavigator(0, {
        loop: false,
        speed: this.baseSpeed,
        pathNavigatorStyle: {
          width: 32,
          height: 32,
          autoRotate: true,
          initRotateDegree: -90,
          strokeStyle: null,
          fillStyle: null,
          content: AMapUI.PathSimplifier.Render.Canvas.getImageContent(carIcon),
          pathLinePassedStyle: {
            lineWidth: 0,
            fillStyle: null,
            strokeStyle: null,
            borderStyle: null
          }
        }
      });

      // 绑定导航事件
      this.navg.on("move", this.handleNavgMove);
      this.navg.on("pause", this.handleNavgPause);
      this.handleSpeedChange(this.speedList[1]); // 默认20倍速

      // 设置起点终点标记
      const firstPoint = tracePoints[0];
      const lastPoint = tracePoints[tracePoints.length - 1];
      this.markerStart.show();
      this.markerStart.setPosition([firstPoint.lon, firstPoint.lat]);
      this.markerEnd.show();
      this.markerEnd.setPosition([lastPoint.lon, lastPoint.lat]);

      // 调整地图视野
      setTimeout(() => {
        this.mapInstance.setFitView(null, false, [150, 80, 100, 100], 10);
      }, 300);

      // 计算总距离和时长
      this.distanceAll = this.AMap.GeometryUtil.distanceOfLine(path);
      this.barEndTimes = (this.distanceAll / this.baseSpeed) * 1000;
      this.barEndTime = formatTime(this.barEndTimes);
    },
    handleNavgMove() {
      const movedDistance = this.navg.getMovedDistance();
      this.sliderVal = (movedDistance / this.distanceAll) * 100;

      const playedTime = (this.sliderVal / 100) * this.barEndTimes;
      this.barStartTime = formatTime(playedTime);

      const currentPos = this.navg.getPosition();
      const normalData = this.getNormalizedData();
      this.showInfoWindow({
        lonlat: currentPos,
        infoData: { ...normalData.normalInfo, addr: normalData.normalLonLat, vno: this.currentVno }
      });
    },
    getPreviousNormalTraceIndex() {
      const currentIdx = this.navg.getCursor().idx;
      for (let i = currentIdx; i >= 0; i--) {
        if (this.traceList[i].gtm) return i;
      }
      return 0;
    },
    getNormalizedData() {
      const currentIdx = this.navg.getCursor().idx;
      const prevIdx = this.getPreviousNormalTraceIndex();
      const normalInfo = JSON.parse(JSON.stringify(this.traceList[prevIdx]));

      if (!this.traceList[currentIdx].gtm) {
        normalInfo.spd = this.calculateSvgSpeed().toFixed(2);
      }

      const lonStr = normalInfo.lon.toString().slice(0, -4);
      const latStr = normalInfo.lat.toString().slice(0, -4);
      return {
        normalInfo,
        normalLonLat: `${lonStr},${latStr}`
      };
    },
    calculateSvgSpeed() {
      const { prevIdx, nextIdx } = this.getAdjacentNormalTraceIndices();
      const pathPoints = this.traceList.slice(prevIdx, nextIdx + 1);
      const path = pathPoints.map(p => [p.lon, p.lat]);
      const distance = this.AMap.GeometryUtil.distanceOfLine(path) / 1000; // 公里

      const startTime = Number(this.traceList[prevIdx].gpsTime);
      const endTime = Number(this.traceList[nextIdx].gpsTime);
      const hours = (endTime - startTime) / 3600000; // 小时

      const speed = distance / hours;
      return speed > 100 ? 80 : (speed < 5 ? 5 : speed);
    },
    getAdjacentNormalTraceIndices() {
      const currentIdx = this.navg.getCursor().idx;
      const total = this.traceList.length;
      let prevIdx = 0, nextIdx = total - 1;

      // 查找前一个有效点
      for (let i = currentIdx; i >= 0; i--) {
        if (this.traceList[i].gtm) {
          prevIdx = i;
          break;
        }
      }

      // 查找后一个有效点
      for (let i = currentIdx; i < total; i++) {
        if (this.traceList[i].gtm) {
          nextIdx = i;
          break;
        }
      }

      return { prevIdx, nextIdx };
    },
    handleNavgPause() {
      if (this.navg.cursor.idx === this.traceList.length - 1) {
        this.navg.stop();
        this.playStatus = "stop";
      }
    },
    createPathSimplifier() {
      const pathStyle = {renderAllPointsIfNumberBelow: 1e4,
        pathTolerance: 2,
        keyPointTolerance: 1,
        pathLineStyle: {
          lineWidth: 6,
          strokeStyle: "#00BA69",
          borderWidth: 2,
          borderStyle: "#006D46",
          dirArrowStyle: !0
        },
        pathLineHoverStyle: {
          lineWidth: 3,
          strokeStyle: "rgba(204, 63, 88,1)",
          borderWidth: 1,
          borderStyle: "#cccccc",
          dirArrowStyle: !1
        },
        pathLineSelectedStyle: {
          lineWidth: 6,
          strokeStyle: "#00BA69",
          borderWidth: 2,
          borderStyle: "#006D46",
          dirArrowStyle: !0
        },
        dirArrowStyle: {
          stepSpace: 35,
          strokeStyle: "#ffffff",
          lineWidth: 2
        },
        startPointStyle: {
          radius: 4,
          fillStyle: "#109618",
          lineWidth: 1,
          strokeStyle: "#eeeeee"
        },
        endPointStyle: {
          radius: 4,
          fillStyle: "#dc3912",
          lineWidth: 1,
          strokeStyle: "#eeeeee"
        },
        keyPointStyle: {
          radius: 3,
          fillStyle: "rgba(8, 126, 196, 1)",
          lineWidth: 1,
          strokeStyle: "#eeeeee"
        },
        keyPointHoverStyle: {
          radius: 4,
          fillStyle: "rgba(0, 0, 0, 0)",
          lineWidth: 2,
          strokeStyle: "#ffa500"
        },
        keyPointOnSelectedPathLineStyle: {
          radius: 4,
          fillStyle: "rgba(8, 126, 196, 1)",
          lineWidth: 2,
          strokeStyle: "#eeeeee"
        }
      };
      var l={
        lineWidth: 0,
        fillStyle: null,
        strokeStyle: null,
        borderStyle: null
      };
      this.pathSimplifierIns = new AMapUI.PathSimplifier({
        zIndex: 100,
        map: this.mapInstance,
        getPath: (pathData) => pathData.path,
        getHoverTitle: (pathData, pathIndex, pointIndex) => {
          return pointIndex >= 0
              ? `${pathData.name}，点：${pointIndex}/${pathData.path.length}`
              : `${pathData.name}，点数量${pathData.path.length}`;
        },
        renderOptions: {
          renderAllPointsIfNumberBelow: pathStyle.renderAllPointsIfNumberBelow,
          pathTolerance: pathStyle.pathTolerance,
          keyPointTolerance: pathStyle.keyPointTolerance,
          pathLineStyle: pathStyle.pathLineStyle,
          pathLineSelectedStyle: pathStyle.pathLineSelectedStyle,
          pathLineHoverStyle: pathStyle.pathLineHoverStyle,
          startPointStyle: l,
          endPointStyle: l,
          keyPointStyle: l,
          keyPointHoverStyle: pathStyle.keyPointHoverStyle,
          keyPointOnSelectedPathLineStyle: l
        }
      });

      // 轨迹点点击事件（保持不变）
      this.pathSimplifierIns.on("pointClick", (pathIndex, pointData) => {
        this.navg.stop();
        this.navg.start();
        this.navg.pause();
        this.playStatus = "pause";
        this.navg.moveToPoint(pointData.pointIndex);
        // 2. 新增：获取点击位置的行驶距离，赋值给pauseDistance
        this.pauseDistance = this.navg.getMovedDistance();
        // 原有获取地址逻辑保留
        this.setGeocoderAddress();
      });
    },
    async setGeocoderAddress() {
      const currentIdx = this.navg.getCursor().idx;
      const currentPoint = this.traceList[currentIdx];
      const currentPos = this.navg.getPosition();
      const normalData = this.getNormalizedData();

      try {
        const address = await this.getAddressByLonLat(currentPos);
        this.showInfoWindow({
          lonlat: currentPos,
          infoData: {
            ...normalData.normalInfo,
            gpsStatus: currentPoint.gpsStatus,
            addr: address,
            vno: this.currentVno
          }
        });
      } catch (err) {
        console.error("获取地址失败：", err);
      }
    },
    getAddressByLonLat(lonlat) {
      return new Promise((resolve, reject) => {
        this.geocoder.getAddress(lonlat, (status, result) => {
          if (status === "complete" && result.info === "OK") {
            resolve(result.regeocode.formattedAddress);
          } else {
            reject(new Error("地址解析失败"));
          }
        });
      });
    },
    initStartEndMarkers() {
      // 起点图标
      const startMarkerIcon = new this.AMap.Icon({
        size: new this.AMap.Size(26, 33),
        image: startIcon
      });
      // 终点图标
      const endMarkerIcon = new this.AMap.Icon({
        size: new this.AMap.Size(26, 33),
        image: endIcon
      });
      // 停车点图标
      this.markerStopIcon = new this.AMap.Icon({
        size: new this.AMap.Size(26, 33),
        image: stopIcon
      });

      // 初始化起点标记
      this.markerStart = new this.AMap.Marker({
        icon: startMarkerIcon,
        zIndex: 20,
        offset: new this.AMap.Pixel(-15, -35)
      });
      this.markerStart.hide();
      this.mapInstance.add(this.markerStart);

      // 初始化终点标记
      this.markerEnd = new this.AMap.Marker({
        icon: endMarkerIcon,
        zIndex: 20,
        offset: new this.AMap.Pixel(-15, -35)
      });
      this.markerEnd.hide();
      this.mapInstance.add(this.markerEnd);
    },
    renderParkingMarkers() {
      // 清除现有停车点标记
      this.mapInstance.remove(this.markerStopList);
      this.markerStopList = [];

      this.showTrackParkingDetailList.forEach(parking => {
        const marker = new this.AMap.Marker({
          icon: this.markerStopIcon,
          zIndex: 20,
          position: [parking.beginLon, parking.beginLat],
          offset: new this.AMap.Pixel(-13, -33)
        });

        // 查找停车点对应的轨迹点索引
        const pointIndex = this.traceList.findIndex(point =>
            point.lon == parking.beginLon &&
            point.lat == parking.beginLat &&
            point.gtm === parking.startGtm
        );

        // 绑定点击事件
        marker.on("click", () => {
          this.navg.stop();
          this.navg.start();
          this.navg.pause();
          this.playStatus = "pause";
          this.navg.moveToPoint(pointIndex);
          this.setGeocoderAddress();
        });

        this.markerStopList.push(marker);
      });

      // 添加到地图
      this.mapInstance.add(this.markerStopList);
    },
    initMapPlugins() {
      // 初始化信息窗口
      this.infoWindow = new this.AMap.InfoWindow({
        isCustom: true,
        offset: new this.AMap.Pixel(25, -40)
      });

      // 初始化地理编码
      this.geocoder = new this.AMap.Geocoder({
        city: "全国",
        radius: 1000
      });
    },
    createScaleControl() {
      return new this.AMap.Scale({
        position: { left: "30px", bottom: "92px" }
      });
    },
    formatVehicleOption(vehicle) {
      return {
        label: vehicle.vno,
        value: `${vehicle.vno},${vehicle.vco}`,
        treeId: `${vehicle.vno}_${vehicle.vco}`,
        ...vehicle
      };
    },
    disabledDate(time) {
      const today = new Date(this.$dayjs().format("YYYY-MM-DD") + " 00:00:00").getTime();
      const fifteenDaysAgo = today - 15552000000; // 180天前
      return time.getTime() > today || time.getTime() < fifteenDaysAgo;
    },
    disabledStartDate(time) {
      const today = new Date(this.$dayjs().format("YYYY-MM-DD") + " 00:00:00").getTime();
      const oneYearAgo = today - 31536000000; // 1年前

      if (this.formItem.endTime) {
        const endDate = new Date(this.$dayjs(Number(this.formItem.endTime)).format("YYYY-MM-DD") + " 00:00:00").getTime();
        const endDateMinus2Days = endDate - 172800000; // 结束时间前2天
        return time.getTime() < oneYearAgo || time.getTime() > today || time.getTime() > endDate || time.getTime() < endDateMinus2Days;
      }
      return time.getTime() < oneYearAgo || time.getTime() > today;
    },
    disabledEndDate(time) {
      const today = new Date(this.$dayjs().format("YYYY-MM-DD") + " 00:00:00").getTime();
      const oneYearAgo = today - 31536000000; // 1年前

      if (this.formItem.startTime) {
        const startDate = new Date(this.$dayjs(Number(this.formItem.startTime)).format("YYYY-MM-DD") + " 00:00:00").getTime();
        const startDatePlus2Days = startDate + 172800000; // 开始时间后2天
        return time.getTime() < oneYearAgo || time.getTime() > today || time.getTime() < startDate || time.getTime() > startDatePlus2Days;
      }
      return time.getTime() < oneYearAgo || time.getTime() > today;
    }
  }
};
</script>
<!-- Track.vue 中 -->
<style>
.amap-icon img {
  width: 100%
}

.infoWidowBox {
  background: hsla(0,0%,100%,.9);
  border-radius: 4px;
  box-shadow: 0 4px 12px 0 rgba(0,0,0,.15);
  height: auto;
  min-height: 156px;
  width: 320px
}

.infoWidowBox .statusBarBox {
  background: #999;
  border-radius: 4px 4px 0 0;
  color: #fff;
  display: none;
  font-size: 16px;
  height: 40px;
  line-height: 40px;
  position: relative;
  text-align: center;
  width: 100%
}

.infoWidowBox .statusBarBox .statusBar {
  background: #ff3b30;
  border-radius: 4px 4px 0 0;
  height: 100%;
  left: 0;
  max-width: 100%;
  position: absolute;
  top: 0;
  width: 0;
  z-index: 1
}

.infoWidowBox .statusBarBox .statusLabel {
  position: relative;
  z-index: 9
}

.infoWidowBox .statusBarBox .statusTip {
  background: url(/img/icon-17.ce45740.png) no-repeat;
  background-size: 100% 100%;
  display: none;
  left: 354px;
  padding: 10px 25px;
  position: absolute;
  top: 0;
  white-space: nowrap
}

.infoWidowBox .statusBarBox .statusTip .statusTip1 {
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  height: 21px;
  line-height: 21px;
  text-align: left
}

.infoWidowBox .statusBarBox .statusTip .statusTip2 {
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  height: 18px;
  line-height: 18px;
  text-align: left
}

.infoWidowBox .titleBox {
  align-items: center;
  border-bottom: 1px solid rgba(0,0,0,.15);
  display: flex;
  height: 40px;
  justify-content: flex-start;
  padding-left: 15px;
  width: 100%
}

.infoWidowBox .titleBox .vehInfo {
  display: flex;
  flex-direction: column
}

.infoWidowBox .titleBox .vehInfo .vehNumber {
  align-items: center;
  background: #ffc34a;
  border: 1px solid #666;
  border-radius: 2px;
  color: #111;
  display: flex;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  justify-content: center;
  line-height: 24px;
  margin-bottom: 2px;
  margin-top: 5px;
  white-space: nowrap;
  width: 87px
}

.infoWidowBox .titleBox .vehInfo .vehInfo {
  color: rgba(0,0,0,.65);
  font-size: 14px;
  font-weight: 400;
  height: 20px
}

.infoWidowBox .titleBox .speedBox {
  align-items: center;
  background: #00ba69;
  color: #fff;
  display: flex;
  font-size: 16px;
  height: 100%;
  justify-content: center;
  width: 92px;
  margin-left: auto;
}
.speedBox{
  margin-right: 15px;
}

.infoWidowBox .markerContent {
  color: #888;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  line-height: 15px;
  padding: 12px 10px;
}

.infoWidowBox .markerContent .markerLine {
  display: flex
}

.infoWidowBox .markerContent .markerLine .markerS1 {
  color: rgba(0,0,0,.65);
  width: 65px
}

.infoWidowBox .markerContent .markerLine .markerS2 {
  color: rgba(0,0,0,.85);
  flex: 1
}

.infoWidowBox .markerBtnBox {
  display: flex;
  justify-content: center;
  margin-top: 10px
}

.infoWidowBox .markerBtnBox .btnItem {
  align-items: center;
  background: no-repeat;
  background-position: 7px;
  background-size: 20px 20px;
  border: 1px solid #1676ff;
  border-radius: 4px;
  color: #1676ff;
  cursor: pointer;
  display: flex;
  height: 28px;
  margin-right: 10px;
  padding-left: 28px;
  width: 90px
}

.infoWidowBox .markerBtnBox .btnItem1 {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAgNJREFUSEvNlcFLVFEUxr9zR01tFKzFzOhGHRObhf4DBSOUGVkbF7UyxTbiQkEhexMi0jwVDHIhbhTTVS3apJGWoFD/gC5UqskgnBk3Cjpmpt4T13jwcF6Dihe8y8O53+985957LjGzCxoXnStAgYFmZXbVxOBxTZ/Igc+QnUo4ZoruMwP4OxHY3kMjM24AXPRPmFaIMHMxHSORbiymgv3XQcNLpE99Qb+UXCsEDV0gTF7JRUSJfd2Ef5dRIyU3CUFvqkvRPlqPPSeQI0CJv1/GOyZsBDx4NNuKLafNlS+Qs7iGYWLOu11Gd5wgjgCfgQHJ8L6+hQfBIDhVC+bmQPen8UoQ4jETLUdzkwCq54k//CHgpav2yv3PULzzC3eVQFY2JiJP8d0SO3QS5yV3BlUdPZMkgPcJnhNhPWYibAkUhPBw/4BNAr9VMQbdS3ORsRrGmJXjMxBixqV4D9rsLpIAng7MZ7lQ9yOMeZWoKk8k+FNOJl371oUVFSvpQtHWb/7sdtN1y0lhCBU7Bxhf60WFI0A9Igl5WUpqL8+j/I+PkVCJ+QZapJRl8V7RZN/o7ZBDQojlqIkBFb/ZB/fCBkeF4H5i8TPag9HDC22NCu0AqzptLbIA2g9Z+zVVTrQ+NAXQPiosiLZhZ7/v2sa104DT8uHYQdq/zON+kymH3WlEUu35C6ingihxnz1nAAAAAElFTkSuQmCC)
}

.infoWidowBox .markerBtnBox .btnItem2 {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAsdJREFUSEvllF1Ik3EUxp/zvnPOgQ1GMT9YaqZJlBdJXhgFeiMVpEQGQl10kYQXUkiyuVxruY8QUYwkJCoqkBDUguzjIi/6uPADIitMo2nq1KhZKrjc3vfEioFszk2om3ov//+H/+89z3nOIWYW8Rc/+j8A6WbkLvuxn1nOZghaAr4SYTReiR6XBUNrObymRelm5C/5cAnMqUR0TyQMiQI8kgytxNjJzCUA3AlKqhmzom81UERAqgmVfomNcSIZzIfRXpEHOfSBtkEI1k6U+yR2KgRyTtlxJVQTEZBci8saNRqGz+FTtJDl1GPz3CI/FAVqcttxbaX+j6Uosw5bFn38fIOSikatGA5CYgboa1EsEzJ35OD64+PwrlZViglVsoR9M04cWTdAZ+BvAuiJTNgVJ6Jmsh6doZDi21C9eotJ/SZkDVRjLnAfcwU6A/tnnaTQ12Hvsg/NBHjUSpz5aMWblaAkI3cpiG5N2tEVBsi2IC1wOGLBeOjfBQGB80B6LnThpN/PZrWSSlxWDAT1SUY0CsC424GWMEBqLaplxsZpB4wxAs6rFVTiqkd/UJ9shEMgfJmyozEMkGJCuSzJB2ecwrFIgKgWGXBHEPHAbUP7qhZ99/LLi2WkDx0snYHnBYEeyRy5yQHr6jp4QqOigqDNYU3WGfiFkqhhwoHulVUEYuonZOTm4GakmOqNKF1mPjvrpD0RY5pmQpFX4tbtSbS79zQWok1x8L6wGYnvZrhfJVLluA1P15yDZCNaGEjPz0DZ/Qr8iAY51Ib4Phc6CBibdqAq6qqwdEC8OogbALYmqnBi1IL3kSBZFmxb8P7SfjiVhxOWMkhRAUHB740KEwG9IqE7ToHXiQnwLCxB6/MjV2KUMlCoEGGbsqF1Xes6KC5ogmbsM47KwAFmzgZIC7CHiEYEoCdTg7vPDJiPVGHMqyJaH/5dwE8wJ1soqUTP+AAAAABJRU5ErkJggg==)
}

.speedSelectBox {
  background: rgba(0,0,0,.3)!important;
  border: none;
  border-radius: 2px 2px 0 0;
  min-width: 80px!important;
  width: 80px
}

.speedSelectBox .popper__arrow {
  display: none
}

.speedSelectBox .speedSelect {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center
}

.speedSelectBox .speedSelect>span {
  color: #000;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 10px
}

.speedSelectBox .speedSelect>span:last-of-type {
  margin-bottom: 0
}

.optItem {
  border: 1px solid #666;
  border-radius: 2px;
  color: #111;
  display: inline-block;
  height: 24px;
  line-height: 24px;
  padding: 0 10px
}

.optItem2 {
  background: #ffc34a
}

.optItem1 {
  background: #1677ff;
  color: #fff
}

.optItem3 {
  background: #000;
  color: #fff
}

.optItem5 {
  background: linear-gradient(180deg,#ecae3b,#37cc36)
}

.optItem6 {
  background: linear-gradient(180deg,#fcfdfe,#9beda9 50%,#37cc36)
}

.toolBar {
  align-items: center;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 12px 0 rgba(0,0,0,.15);
  display: flex;
  height: 50px;
  left: 30px;
  padding: 9px 20px;
  position: absolute;
  top: 10px
}

.toolBar .inp1,.toolBar .inp2 {
  margin-right: 12px;
  width: 120px
}

.toolBar .inp3 {
  margin-right: 12px;
  width: 200px
}

.progressbarBox {
  align-items: center;
  background: rgba(0,0,0,.3);
  border-radius: 2px;
  bottom: 20px;
  display: flex;
  height: 52px;
  left: 0;
  position: absolute;
  right: 0
}

.progressbarBox .progressBar {
  align-items: center;
  display: flex;
  flex: 1
}

.progressbarBox .progressBar .startTime {
  font-size: 14px;
  margin: 0 16px
}

.progressbarBox .progressBar .endTime {
  font-size: 14px;
  margin-left: 16px
}

.progressbarBox .progressBar .bar {
  border-radius: 5px;
  flex: 1;
  width: 0
}

.progressbarBox .progressBar .bar .el-slider__runway {
  background: #bbb;
  height: 10px
}

.progressbarBox .progressBar .bar .el-slider__bar {
  background: #1677ff;
  height: 10px
}

.progressbarBox .progressBar .icon {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAihJREFUWEfNlz9s00AUxr8n2/FQxIbUhQWhLA1iIygTYu3EBOzQGyxFTLAxsJUJRbKUA3bYMnXIErGlsKGEDZFIXZowpWql2Dnr0LPiygkxPaJUV6/33nc/v393RzD8wjC85jjOLhE9BHAXwC0A1+fuJwB+Afiute4kSXIQBMGpiTRdZBSG4W3XdV8BeApg6yL7+foZgE9Kqf0gCH7+y6cQoNFo+L7vvyGiF1rrkuHGC2ZEFGut30VR9Lper0erNFYChGG47ThOi4jur7Pxso/W+jBJkkdBEBwvr/0FIKW8A+AAwM1NbJ7TOAKwK4To5XUXAPjPXdf9dgmbZ3seKaXu5SNxDsA5L5VKXzYV9qLocTriOH6Q1cQ5gJRyH8DLDYe9SO6tEII7CykAt5rneT9Mqt3zPDiOg+l0ujYrd8dsNtvhFk0BpJQfADwzUaxWqyiXy2i32xiPxyYuRTYfhRDPiSec67rcHkZDplaroVKpQCmFTqeD4XC4LsSZUmqbms3mYyL6bKqSAbC91hrdbhf9ft/UfcFOa/2EpJQSwJ6pQh4g8+n1einIGt97BjgEUDV1XgXAvoPBIE1JkiSmUmz3lQG4km6YehUBsP9oNEqL8z865DcDcD/5mwBgjclkglarhTiOTSSjKwFgPQXWi9BuG1ofRNZHsfXD6Eocx/Mo2LuQMID1K9k8FfYupdngtnotzyCsPkwyCKtPs/w5au1xunyYX9bz/A8DkHri/gbYJgAAAABJRU5ErkJggg==) no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  height: 32px;
  margin-left: 16px;
  width: 32px
}

.progressbarBox .progressBar .icon.isCanPlay {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAitJREFUWEfNlz9oFEEUh793EVdisLtLGhuxC2KhqGAjNqLBwsqzMFVioQg2ZlMlKhY5bQRtYiy0MlY2nqWkiHAaLCTYSUDS6K1aBO+8i2afzLobL+f9GeLKZNt5v998+2bmvRnB8stOal+mzpCGHEfYD+wBdsXyFWAJ5a1keBF6FIPr8s3GWroFZcd1L+CLcg7Y2S0+Hq+o8BgoBFPyvpOmPcBl9XK93ACuANstJ24OWwXulKtMcFfqrTxaAmSv6oBkeAoc2eTEzbKShpwJbsvH5oG/APp93RcKRVF2pzR5ZKPCckYZ+lSQxUbfDQDmz+nhddqTJxMaCNY41JiJPwC/13wuxbS3S2CpXOVYsifWAXK+FoCxNNPewetWuSC+GY8AzFET5Z3Nbu/zwNsGXyr/hLqqwqA5ognAjCgjNpYTpyB/AM4/hDfLNorWMSo8CKZkVEyFkxrmeFgVmZunYfQofP8BF2fhucnb5r6K7mBA+sf1rCqzth4JgIlfC2GyCDMvbdUb40TIS25MpxEu2Fo0AiSa6Xm4VoRQbV3iOOW+5HwtAYdtpa0AjPbZIlx6ArWftk5R3CsDUDYHwVbWDsDoFz7A8CP4WrV1IzAANcCzlXQCMB5Ln+HEPVgxrt2/+pYAcL4Ejjeh62PovBA5L8VxN7RvRichfzDFZrQl2rGBcHohiQqW6ytZtBROL6Vx3XZ6LU96h9OHyXoDc/k0a+yi7h6nTb38fz3PfwG7dDAcXA+3jAAAAABJRU5ErkJggg==)
}

.progressbarBox .progressBar .iconPause {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAgNJREFUWEfNlztMU2EUgL+T8khAHAgSBlkaYQHCoCnWgRhWJl3QgU0x4SbECQYJA8EBJ0Nym4BuDjDJxGoIQ1saHAxlEcMCA0HiIEJEaA75LTe0hdpbvOTnzufx3fOfp+D3S7s32KMXlR7QTiAM3DxV/wlsgHxB9BN1LNDu/PJjWkoKxd07iIyAPkWpLSlvBIR9kFlUJ3ngfPuXTnGA9alqdkPjIC9RrfLluFBI5A/oWxoyY7QMHV5k42KAlNvEEfMI9y/luFBJSVLJIyLO9jnGcw5Wpjs4Ol5AaQ7EuWdE2KSyopd7L1Zz7eZHwPx5hlTgznMhQkRyI3EGYN58J7QYWNiLhc88R2PmoZcTZwAJdxJlONCwFzMmvCHqjGQLxnzZUlu7dLaXS22qQ7XNlGgWIBF7h+qzcu38l7zIe6KDz4Vsh9v202SS7Y9pq6lncGOJD7tf8/z3N7QSC3eTPvhBNP2xNJtpVnU0CQm3D2WutAbsRwaoCVXweuszo5vLeSoTzV28un2Xg8wxtakZP+ZMAjwR4rFp0AE/GoEDIDNC3E0CXXYAWDYAO8AtSwDfDcBvoNoSwOG1ALD+BLaT0HYZWm9EZbTixGkrdoq0YjfczVrZrdj6MLoW4/hvFGwuJAbA+kpmIKwupd4wsLqWexBWDxMPwuppljubrR2nhQvCFZ3nJ7V0Y+DdzaurAAAAAElFTkSuQmCC) no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  height: 32px;
  margin-left: 16px;
  width: 32px
}

.progressbarBox .changeSpeed {
  color: #000;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  margin-left: 34px;
  margin-right: 30px;
  width: 40px;
  width: 28px
}

.progressbarBox .changeSpeed .changeSpeedText {
  display: inline-block;
  height: 28px;
  line-height: 28px
}

.page-container {
  margin: 0 auto;
  position: relative;
  width: 1280px
}

.mapContainer {
  height: calc(100vh - 185px);
  width: 100%
}

.nav-container {
  display: flex;
  flex-direction: column;
  height: 60px;
  justify-content: center
}

</style>